const LEXICON = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz'
const ENTROPY_CHARS = 4

var lastTime = null
var lastEntropy = new Array(ENTROPY_CHARS)

export default function(time, entropy) {
	var i, now,
		duplicate = false,
		id = new Array(8 + ENTROPY_CHARS)

	// Create a UUID from an explicit point in time
	if (time) {
		now = time
	}
	// Generate a timestamp using the current time, and cache this time to
	// ensure subsequent events have a lexicographically later timestamp
	else {
		now = Date.now()
		duplicate = (now === lastTime)
		lastTime = now
	}

	// Insert the timestamp into the ID
	for (i = 7 ; i >= 0 ; i--) {
		id[i] = LEXICON.charAt(now % 64);
		now = Math.floor(now / 64);
	}

	// Skip generating new entropy if there is an explicit entropy value
	if (entropy != null) {
		// Insert the explicit entropy value, either the first or last letter
		for (i = 0 ; i < ENTROPY_CHARS ; i++) {
			id[i + 8] = (entropy === 1) ? 'z' : '-';
		}
	}
	else {
		// If this is a duplicate timestamp (i.e. the server is generating more than 1 event in the same timestamp)
		// then increment the last entropy array and use it instead
		if (duplicate) {
			for (i = ENTROPY_CHARS - 1 ; i >= 0 && lastEntropy[i] === 63 ; i--) {
				lastEntropy[i] = 0;
			}
			lastEntropy[i]++;
		}
		// Generate a new entropy array
		else {
			for (i = 0 ; i < ENTROPY_CHARS ; i++) {
				lastEntropy[i] = Math.floor(Math.random() * 64);
			}
		}

		// Insert the entropy characters
		for (i = 0 ; i < ENTROPY_CHARS ; i++) {
			id[i + 8] = LEXICON.charAt(lastEntropy[i]);
		}
	}

	// Join the ID and return
	return id.join('');
}
